import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { importProvidersFrom } from '@angular/core';
import { CSP_NONCE } from '@angular/core';

import { AppComponent } from './app/app.component';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const cspNonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content') ?? '';

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(AppModule),
    { provide: CSP_NONCE, useValue: cspNonce }
  ]
}).catch(err => console.error(err));
